// Firebase 설정 및 FCM 초기화
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase 설정
const firebaseConfig = {
  apiKey: "AIzaSyBKG8Oplm-XjUDr53K94hHoXurg0CI49X4",
  authDomain: "acorn-bank-7ae58.firebaseapp.com",
  projectId: "acorn-bank-7ae58",
  storageBucket: "acorn-bank-7ae58.firebasestorage.app",
  messagingSenderId: "718658282657",
  appId: "1:718658282657:web:9ec576fb37fe50896d3ce0",
  measurementId: "G-KMFNWLL2E8"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// FCM 메시징 인스턴스
let messaging = null;

try {
  // HTTPS 환경에서만 FCM 사용 가능
  if ('serviceWorker' in navigator && window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
    messaging = getMessaging(app);

    // IndexedDB 문제 해결을 위한 설정
    if (messaging && messaging.app) {
      // Firebase 오프라인 캐시 비활성화
      try {
        // FCM의 로컬 캐시 설정 조정
        console.log('Firebase 캐시 설정 조정 중...');
      } catch (cacheError) {
        console.log('캐시 설정 조정 실패:', cacheError);
      }
    }
  }
} catch (error) {
  console.log('FCM 초기화 실패:', error);
}

// VAPID 키 (Firebase Console에서 생성)
const vapidKey = "BBQrB1ikaKE507pw6Q9Psoh4v4N7YENGk2nQOj5tpF8_3Jj5R_4VJ8_KyFiSM5B8pqKlf5iVeYMJD4ocBYgXV8k";

// FCM 토큰 요청 (간소화된 안정적인 버전)
// 서버에서 FCM 토큰 생성하는 대안 함수 (개발 중)
export const requestNotificationPermissionServerSide = async () => {
  throw new Error('FCM 알림 기능은 현재 개발 중입니다. 곧 지원될 예정입니다.');
};

export const requestNotificationPermission = async () => {
  // FCM 알림 기능은 현재 개발 중
  try {
    return await requestNotificationPermissionServerSide();
  } catch (serverError) {
    throw new Error(serverError.message);
  }

  // 기존 클라이언트사이드 방법
  if (!messaging) {
    alert('❌ messaging이 null입니다');
    throw new Error('FCM을 사용할 수 없습니다. HTTPS 환경이 필요합니다.');
  }

  alert('✅ messaging 객체 확인됨');

  try {
    // 1. Notification API 지원 확인
    if (!('Notification' in window)) {
      throw new Error('이 브라우저는 알림을 지원하지 않습니다.');
    }

    // 2. 알림 권한 요청
    alert('🔔 알림 권한 요청 시작');
    console.log('알림 권한 요청 중...');
    const permission = await Notification.requestPermission();
    console.log('알림 권한 결과:', permission);
    alert(`🔔 알림 권한 결과: ${permission}`);

    if (permission !== 'granted') {
      alert(`❌ 권한 거부: ${permission}`);
      throw new Error(`알림 권한이 거부되었습니다: ${permission}`);
    }

    alert('✅ 알림 권한 승인됨');

    // 3. 서비스 워커 확인/등록
    alert('🔧 서비스 워커 단계 시작');

    if (!('serviceWorker' in navigator)) {
      alert('❌ 서비스 워커 미지원');
      throw new Error('서비스 워커를 지원하지 않는 브라우저입니다.');
    }

    alert('✅ 서비스 워커 지원됨');
    console.log('서비스 워커 등록 확인 중...');
    let registration;

    try {
      alert('🔍 기존 서비스 워커 확인 중...');
      // 기존 등록된 서비스 워커 확인
      registration = await navigator.serviceWorker.getRegistration('/');

      if (!registration) {
        alert('📝 새 서비스 워커 등록 중...');
        console.log('새 서비스 워커 등록...');
        registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/',
          updateViaCache: 'none'
        });
        alert('✅ 서비스 워커 등록 완료');
      } else {
        alert('✅ 기존 서비스 워커 발견');
      }

      console.log('서비스 워커 준비됨:', registration);

      // 서비스 워커가 준비될 때까지 잠시 대기
      alert('⏳ 서비스 워커 준비 대기 중...');
      await new Promise(resolve => setTimeout(resolve, 500));
      alert('✅ 서비스 워커 준비 완료');

    } catch (swError) {
      alert(`❌ 서비스 워커 에러: ${swError.message}`);
      console.error('서비스 워커 문제:', swError);
      throw new Error('서비스 워커 등록에 실패했습니다.');
    }

    // 4. 브라우저 환경 확인
    alert('🔍 브라우저 환경 체크');
    console.log('User Agent:', navigator.userAgent);
    console.log('Online 상태:', navigator.onLine);
    console.log('Protocol:', window.location.protocol);

    // HTTPS 강제 확인
    if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
      alert('❌ HTTPS 연결이 필요합니다');
      throw new Error('HTTPS 연결이 필요합니다.');
    }
    alert('✅ HTTPS 연결 확인됨');

    // 5. FCM 토큰 요청 (타임아웃 설정)
    alert('🎯 FCM 토큰 요청 시작');
    console.log('FCM 토큰 요청 중...');
    console.log('현재 도메인:', window.location.hostname);
    console.log('현재 프로토콜:', window.location.protocol);
    console.log('현재 전체 URL:', window.location.href);
    console.log('VAPID 키:', vapidKey);
    console.log('서비스 워커 등록:', registration);

    let token;
    try {
      alert('🔐 getToken 호출 중...');

      // 더 긴 타임아웃과 재시도 로직
      let attempts = 0;
      const maxAttempts = 3;

      while (attempts < maxAttempts) {
        try {
          alert(`🔄 시도 ${attempts + 1}/${maxAttempts}`);

          // 모바일 브라우저 호환성을 위한 단계별 접근
          try {
            alert('🎯 FCM 토큰 생성 시작...');

            // 1단계: 기본 토큰 요청
            token = await getToken(messaging, {
              vapidKey: vapidKey,
              serviceWorkerRegistration: registration
            });

            alert('✅ 1단계 토큰 생성 성공');

          } catch (getTokenError) {
            alert(`❌ 1단계 실패: ${getTokenError.message}`);

            // 2단계: 서비스워커 없이 재시도
            try {
              alert('🔄 2단계: 서비스워커 없이 재시도...');

              token = await getToken(messaging, {
                vapidKey: vapidKey
                // serviceWorkerRegistration 제거
              });

              alert('✅ 2단계 토큰 생성 성공');

            } catch (secondError) {
              alert(`❌ 2단계도 실패: ${secondError.message}`);

              // 3단계: 잠시 대기 후 다시 시도
              alert('⏳ 3단계: 대기 후 재시도...');
              await new Promise(resolve => setTimeout(resolve, 3000));

              token = await getToken(messaging, {
                vapidKey: vapidKey,
                serviceWorkerRegistration: registration
              });

              alert('✅ 3단계 토큰 생성 성공');
            }
          }

          if (token) {
            alert(`✅ 토큰 생성 성공: ${token.substring(0, 20)}...`);
            break;
          }

        } catch (attemptError) {
          attempts++;
          alert(`❌ ${attempts}번째 시도 실패: ${attemptError.message}`);

          if (attempts >= maxAttempts) {
            throw attemptError;
          }

          // 다음 시도 전 잠시 대기
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
      }

    } catch (tokenError) {
      alert(`❌ 최종 토큰 생성 실패: ${tokenError.message}`);
      console.error('FCM getToken 상세 에러:', tokenError);
      console.error('에러 코드:', tokenError.code);
      console.error('에러 메시지:', tokenError.message);
      console.error('에러 스택:', tokenError.stack);

      // Firebase specific 에러 코드 확인
      if (tokenError.code === 'messaging/unsupported-browser') {
        throw new Error('이 브라우저는 FCM을 지원하지 않습니다.');
      } else if (tokenError.code === 'messaging/permission-blocked') {
        throw new Error('알림 권한이 차단되었습니다. 브라우저 설정을 확인해주세요.');
      } else if (tokenError.code === 'messaging/vapid-key-required') {
        throw new Error('VAPID 키 설정에 문제가 있습니다.');
      } else if (tokenError.code === 'messaging/invalid-vapid-key') {
        throw new Error('유효하지 않은 VAPID 키입니다.');
      } else if (tokenError.message && tokenError.message.includes('network')) {
        throw new Error('Firebase 서버 연결에 실패했습니다. 인터넷 연결을 확인해주세요.');
      } else if (tokenError.message && tokenError.message.includes('timeout')) {
        throw new Error('요청 시간이 초과되었습니다. 다시 시도해주세요.');
      } else {
        throw new Error(`알림 토큰 생성 실패: ${tokenError.message || '알 수 없는 오류'}`);
      }
    }

    if (!token) {
      alert('❌ 토큰이 null입니다');
      throw new Error('FCM 토큰을 받을 수 없습니다.');
    }

    alert(`🎉 최종 토큰 확인: ${token.substring(0, 20)}...`);
    console.log('FCM 토큰 생성 완료:', token.substring(0, 20) + '...');
    alert('🚀 토큰 반환 준비');
    return token;

  } catch (error) {
    alert(`💥 전체 에러 발생: ${error.message}`);
    console.error('알림 활성화 실패:', error.message);

    // 사용자에게 더 명확한 에러 메시지 제공
    let userMessage = '';
    if (error.message.includes('permission')) {
      userMessage = '알림 권한이 차단되었습니다. 브라우저 설정에서 알림을 허용해주세요.';
    } else if (error.message.includes('unsupported')) {
      userMessage = '이 브라우저는 알림을 지원하지 않습니다.';
    } else if (error.message.includes('service worker')) {
      userMessage = '서비스 워커 등록에 실패했습니다. 페이지를 새로고침해주세요.';
    } else if (error.message.includes('token')) {
      userMessage = 'Firebase 토큰 생성에 실패했습니다. 네트워크 연결을 확인해주세요.';
    } else {
      userMessage = `알림 설정 실패: ${error.message}`;
    }

    alert(`📋 최종 사용자 메시지: ${userMessage}`);
    throw new Error(userMessage);
  }
};

// 포그라운드 메시지 수신
export const onMessageListener = () => {
  if (!messaging) {
    return Promise.reject(new Error('FCM을 사용할 수 없습니다.'));
  }

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('포그라운드 메시지 수신:', payload);

      // 브라우저 알림 표시
      if (payload.notification) {
        const { title, body, icon } = payload.notification;

        if (Notification.permission === 'granted') {
          new Notification(title || '도토리 저금통', {
            body: body || '새로운 알림이 있습니다.',
            icon: icon || '/favicon.ico',
            badge: '/favicon.ico',
            tag: 'acorn-bank',
            renotify: true
          });
        }
      }

      resolve(payload);
    });
  });
};

// 알림 권한 상태 확인
export const getNotificationPermission = () => {
  if (!('Notification' in window)) {
    return 'unsupported';
  }
  return Notification.permission;
};

// FCM 사용 가능 여부 확인 (개선된 버전)
export const isFCMSupported = () => {
  return !!(messaging && 'serviceWorker' in navigator);
};

// 브라우저 및 환경 호환성 체크
export const checkFCMCompatibility = () => {
  const checks = {
    https: window.location.protocol === 'https:' || window.location.hostname === 'localhost',
    serviceWorker: 'serviceWorker' in navigator,
    notification: 'Notification' in window,
    messaging: !!messaging,
    userAgent: navigator.userAgent,
    mobile: /Mobile|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent)
  };

  const isSupported = checks.https && checks.serviceWorker && checks.notification && checks.messaging;

  return {
    ...checks,
    isSupported,
    recommendations: getRecommendations(checks)
  };
};

// 사용자에게 권장사항 제공
const getRecommendations = (checks) => {
  const recommendations = [];

  if (!checks.https) {
    recommendations.push('HTTPS 연결이 필요합니다.');
  }

  if (!checks.serviceWorker) {
    recommendations.push('Service Worker를 지원하지 않는 브라우저입니다.');
  }

  if (!checks.notification) {
    recommendations.push('브라우저 알림을 지원하지 않습니다.');
  }

  if (!checks.messaging) {
    recommendations.push('Firebase Messaging 초기화에 실패했습니다.');
  }

  if (checks.mobile) {
    if (checks.userAgent.includes('iPhone') || checks.userAgent.includes('iPad')) {
      recommendations.push('iOS Safari에서는 PWA로 설치 후 사용하세요.');
    } else if (checks.userAgent.includes('Android')) {
      recommendations.push('Chrome 브라우저 사용을 권장합니다.');
    }
  }

  if (recommendations.length === 0) {
    recommendations.push('모든 요구사항이 충족되었습니다.');
  }

  return recommendations;
};

// Service Worker 수동 등록 함수 (fallback)
export const manuallyRegisterServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service Worker를 지원하지 않는 브라우저입니다.');
  }

  try {
    console.log('🔧 Service Worker 수동 등록 시작...');

    // 기존 등록 해제
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      console.log('기존 Service Worker 해제:', registration);
      await registration.unregister();
    }

    // 새로 등록
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
      updateViaCache: 'none'
    });

    console.log('✅ Service Worker 수동 등록 완료:', registration);

    // 활성화 대기
    if (registration.installing) {
      await new Promise((resolve) => {
        registration.installing.addEventListener('statechange', () => {
          if (registration.installing.state === 'activated') {
            resolve();
          }
        });
      });
    }

    return registration;

  } catch (error) {
    console.error('❌ Service Worker 수동 등록 실패:', error);
    throw error;
  }
};

// FCM 활성화 여부 (현재 개발 중)
export const IS_FCM_ENABLED = false;

export default messaging;